import { render, staticRenderFns } from "./teamJob.vue?vue&type=template&id=2efcd96c&scoped=true"
import script from "./teamJob.vue?vue&type=script&lang=js"
export * from "./teamJob.vue?vue&type=script&lang=js"
import style0 from "./teamJob.vue?vue&type=style&index=0&id=2efcd96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efcd96c",
  null
  
)

export default component.exports